module.exports = __webpack_public_path__ + "static/media/fly0201.f66a440c.webp";